import { Tag, TagVehicle, Vehicle } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface TagInput {
  name: string;
  client_id: number;
  value: string;
  vehicles?: number[];
}

interface TagSingleResponse extends DefaultResponse<Tag, false> {}

export interface TagAndVehicleInfoResponse {
  tags: Tag[];
  vehicles_with_no_tags: Vehicle[];
}

export interface TagAndVehicleInfoApiResponse {
  data: TagAndVehicleInfoResponse;
}

export const tagService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<Tag>>("/tags", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async store(data: TagInput) {
    const response = await api.post("/tags", {
      name: data.name,
      client_id: data.client_id,
      value: data.value,
      vehicles: data.vehicles,
    });
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<TagSingleResponse>(`/tags/${id}`);
    return response.data;
  },

  async update(id: number | string, data: TagInput) {
    const response = await api.put(`/tags/${id}`, {
      name: data.name,
      client_id: data.client_id,
      value: data.value,
      vehicles: data.vehicles,
    });
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/tags/${id}`);
    return response.data;
  },

  async getTagAndVehicleInfo() {
    const response =
      await api.get<TagAndVehicleInfoApiResponse>("/tags/vehicle_info");
    return response.data;
  },

  async updateTagsFromVehicle(vehicleId: number, data: { vehicles: number[] }) {
    const response = await api.put(
      `/tag_vehicle/${vehicleId}/from_vehicle`,
      data,
    );
    return response.data;
  },

  async getVehicleTags(vehicleId: number) {
    const response = await api.get<DefaultResponse<TagVehicle>>(
      `tag_vehicle/${vehicleId}/by_vehicle`,
    );
    return response.data;
  },
};
